import topButtonUrl from '@/assets/icons/top-button.png'

import { FloatingButton } from './styles'

interface TopButtonProps {
  /** 노출 여부 — 부모(ServiceAreaPage)에서 sticky pinned 상태로 결정 */
  visible: boolean
}

const SCROLL_TO_TOP_OPTIONS: ScrollToOptions = { top: 0, behavior: 'smooth' }

/**
 * 노출 크기 48×48. PNG 자산은 112×112 (Figma 노드 56×56 의 2x export, 외곽 그림자 영역 포함).
 *
 * SVG `<img>` 사용 시 모바일 WebView 의 raster cache 가 device pixel ratio 를 제대로 반영 못 해
 * 화질이 흐릿해지는 이슈 발생 (특히 SVG filter dropShadow). 자산을 PNG 2x 로 교체하여 해결.
 */
const ICON_SIZE = 48

/**
 * 페이지 최상단 floating 버튼.
 *
 * 노출 조건은 부모가 결정 — Tabs 가 sticky 로 pinned 된 시점이 표준.
 * IntersectionObserver 로 sentinel(Tabs 위 빈 div) 가시성 추적.
 *
 * 스크롤 대상:
 *  본 앱의 실제 scroll container 는 `#root` (GlobalStyles 에서 html/body=overflow:hidden,
 *  #root=overflow-y:auto 로 설정). `window.scrollTo` 는 viewport 기준이라 #root 의
 *  스크롤을 움직이지 못함 → #root 를 직접 찾아 scrollTo.
 *
 *  Fallback 순서: #root → scrollingElement → documentElement
 *
 * 시각:
 *  top-button.png(2x) 한 장에 원형 + 화살표 + 그림자 모두 포함 (디자인 자산 그대로).
 *  CSS 는 fixed positioning + fade transition 만 담당.
 */
export default function TopButton({ visible }: TopButtonProps) {
  const handleClick = () => {
    const target = document.getElementById('root') ?? document.scrollingElement ?? document.documentElement
    target.scrollTo(SCROLL_TO_TOP_OPTIONS)
  }

  return (
    <FloatingButton
      type='button'
      data-visible={visible}
      onClick={handleClick}
      aria-label='맨 위로 이동'
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}>
      <img src={topButtonUrl} alt='' width={ICON_SIZE} height={ICON_SIZE} />
    </FloatingButton>
  )
}
